import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import YouTube from "react-youtube";
import { withTranslation } from "react-i18next";

const VideoTutorialDialog = ({ open, onClose, t, i18n }) => {
  const userLanguage = i18n?.language;
  let isFr = userLanguage?.startsWith("fr");
  if (isFr === undefined || isFr === null) {
    isFr = true;
  }

  const opts = {
    height: "500",
    width: "100%",
    playerVars: {
      autoplay: 1,
      mute: 1,
      controls: 1,
      modestbranding: 1,
      rel: 0,
    },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "16px",
          backgroundColor: "#F8F9FA",
        },
      }}
    >
      <DialogContent style={{ padding: 0 }}>
        <Box position="relative">
          <IconButton
            onClick={onClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box p={3}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ fontWeight: 600, color: "#2A3142" }}
            >
              {t("video_tutorial_dialog.title")}
            </Typography>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              {t("video_tutorial_dialog.description")}
            </Typography>
          </Box>

          <Box p={2} style={{ backgroundColor: "#000" }}>
            <YouTube
              videoId={isFr ? "wXnhoDOi_qQ" : "XX3L5TACDrQ"}
              opts={opts}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default withTranslation()(VideoTutorialDialog);
